<nav *ngIf="editMode" class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver">
            <i class="fa fa-chevron-left"></i>
        </button>
        <button *ngIf="!visibilitySpinnerSave" [disabled]="!allowToSave" type="button" class="btn btn-outline-success" (click)="onSave()" title="Guardar">
            <i class="fa fa-save"></i> Guardar
        </button>
        <button *ngIf="visibilitySpinnerSave" [disabled]="true" type="button" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Guardando
        </button>
    </form>
</nav>

<app-aforo-edit [editMode]="editMode" [aforo]="aforo" [formGroup]="formGroup" [comunidadesAutonomas]="comunidadesAutonomas" [provincias]="provincias" [recintos]="recintos" [cultivos]="cultivos" (comunidadAutonomaSelected)="onComunidadAutonomaSelected($event)" (provinciaSelected)="onProvinciaSelected($event)" (recintoSelected)="onRecintoSelected($event)" [controlsDisabled]="controlsDisabled"></app-aforo-edit>
